import { render, staticRenderFns } from "./EmissionExpiryDate.vue?vue&type=template&id=567ef244&"
import script from "./EmissionExpiryDate.vue?vue&type=script&lang=js&"
export * from "./EmissionExpiryDate.vue?vue&type=script&lang=js&"
import style0 from "./EmissionExpiryDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports